import React, { useMemo } from "react";
import { FaKey, FaExchangeAlt, FaTrash, FaUser } from "react-icons/fa";
import "./../../styles/SupportDashboard.css";

export default function UserDrawer({
  isOpen,
  user,
  onClose,
  onResetPassword,
  onTransfer,
  onDelete
}) {
  const safe = useMemo(() => user || {}, [user]);
  if (!isOpen) return null;

  return (
    <div className="sd-drawer-backdrop" role="dialog" aria-modal="true">
      <aside className="sd-drawer">
        <div className="sd-drawer-head">
          <div className="sd-drawer-title">
            <div className="sd-drawer-ic"><FaUser /></div>
            <div>
              <div className="sd-drawer-username">{safe.username || "User"}</div>
              <div className="sd-drawer-sub">
                {safe.userType ? `Type: ${safe.userType}` : "—"}
                <span className="sd-dot">•</span>
                {safe.groupName ? safe.groupName : (safe.groupId ? `Group #${safe.groupId}` : "No group")}
              </div>
            </div>
          </div>

          <button className="sd-icon-btn" onClick={onClose} aria-label="Close" type="button">
            ✕
          </button>
        </div>

        <div className="sd-drawer-body">
          <div className="sd-kv">
            <div className="sd-k">Status</div>
            <div className="sd-v">{safe.status || "—"}</div>
          </div>

          <div className="sd-kv">
            <div className="sd-k">Last login</div>
            <div className="sd-v">{safe.lastLogin || "—"}</div>
          </div>

          <div className="sd-divider" />

          <div className="sd-drawer-actions">
            <button className="sd-action-lg" onClick={onResetPassword} type="button">
              <FaKey /> Reset password
              <span className="sd-action-desc">Secure reset with audit reason.</span>
            </button>

            <button className="sd-action-lg" onClick={onTransfer} type="button">
              <FaExchangeAlt /> Action transfer
              <span className="sd-action-desc">Move user to another group safely.</span>
            </button>

            <div className="sd-danger-zone">
              <div className="sd-danger-title">Danger zone</div>
              <button className="sd-danger-btn" onClick={onDelete} type="button">
                <FaTrash /> Delete user
              </button>
              <div className="sd-danger-hint">
                Deletion should require typed confirmation and be fully audited.
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}
